import { render, staticRenderFns } from "./FilesTile.vue?vue&type=template&id=21140eea"
import script from "./FilesTile.vue?vue&type=script&lang=ts"
export * from "./FilesTile.vue?vue&type=script&lang=ts"
import style0 from "./FilesTile.vue?vue&type=style&index=0&id=21140eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports